import { Injectable } from "@angular/core";
export interface ColorPalette
{
  baseColors: Array<string>;
  additionalColors: Array<string>;
}

@Injectable()
export class ColorPaletteService
{
  private baseColors: Array<string> = [
      '#800000', '#a52a2a', '#dc143c', '#ff0000', '#ff1493', '#cd5c5c',
      '#bc8f8f', '#fa8072', '#ffc0cb', '#ff6347', '#ff4500', '#ff7f50',
      '#d2691e', '#a0522d', '#f4a460', '#ffa500', '#ffd700', '#ffdeb1',
      '#ffdab9', '#ffff00', '#6b8e23', '#008000', '#00ff00', '#00ff7f',
      '#98fb98', '#66cdaa', '#7fffd4', '#40e0d0', '#20b2aa', '#008080',
      '#00ffff', '#87ceeb', '#4682b4', '#1e90ff', '#0000cd', '#483d8b',
      '#4b0082', '#9400d3', '#8b008b', '#ff00ff', '#ee82ee', '#e6e6fa',
      '#fff0f5', '#f0fff0', '#f0f8ff', '#ffffff', '#000000', '#dcdcdc',
      '#a9a9a9', '#708090',
  ];

  private _colorPalette: ColorPalette = {
    baseColors: this.baseColors,
    additionalColors: [],
  };

  public reset(): void
  {
    this._colorPalette.additionalColors = [];
  }

  public get colorPalette(): ColorPalette
  {
    return this._colorPalette;
  }

  public set colorPalette(palette: ColorPalette)
  {
    this._colorPalette = palette;
  }

  public addColors(_colors: Array<string> | string): void
  {
    const colors = typeof _colors === 'string' ? [ _colors ] : _colors;

    const addColor = (color) => {
      const colorIndex = this._colorPalette.additionalColors.indexOf(color);
      if (colorIndex === -1) {
        this._colorPalette.additionalColors.push(color);
      }
    };

    for (const color of colors) {
      addColor(color);
    }
  }
}
